// extracted by mini-css-extract-plugin
export default {"wrapper":"DiagonalLabel_wrapper__OHKFX","line":"DiagonalLabel_line__YFIO8","text":"DiagonalLabel_text__HZjj+"};